"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var SnackbarTheme = function SnackbarTheme() {
  return {
    styleOverrides: {
      root: {
        maxWidth: '300px',
        borderRadius: '8px'
      }
    },
    variants: [{
      props: {
        vertical: true
      },
      style: {
        maxWidth: 'initial',
        '& .MuiSnackbarContent-action': {
          width: 'auto',
          flexDirection: 'column'
        },
        '& .MuiSnackbarContent-root': {
          flexWrap: 'initial'
        },
        '& .MuiSnackbarContent-message': {
          display: 'flex',
          flexWrap: 'initial'
        },
        '& .MuiAlert-action': {
          display: 'none'
        },
        '& .MuiSnackbarContent-action button:first-of-type': {
          borderTopRightRadius: '8px',
          borderBottomLeftRadius: 0
        }
      }
    }]
  };
};

var _default = SnackbarTheme;
exports["default"] = _default;